import styled from '@emotion/styled';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSubFolder } from '../../utils/util';

interface ConfirmProps {
  title: string;
  onConfirm?: () => void | Promise<void>;
  content?: string;
  errorMessage?: string;
  onMount?: () => void | Promise<void>;
}

const Confirm = ({ title, onConfirm, content, errorMessage, onMount }: ConfirmProps) => {
  const location = useLocation();

  const handleConfirm = () => {
    window.location.href = `/${getSubFolder(location.pathname)}`;
  };

  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, []);

  return (
    <ModalOverlay>
      <ModalWrapper>
        <Title>{title}</Title>
        <ErrorMessage>{errorMessage}</ErrorMessage>
        <Content>{content}</Content>
        <button onClick={onConfirm ?? handleConfirm}>확인</button>
      </ModalWrapper>
    </ModalOverlay>
  );
};

export default Confirm;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const ModalWrapper = styled.div`
  position: relative;
  width: 525px;
  height: 258px;
  display: flex;
  flex-direction: column;
  padding: 28px 24px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color[2]};
  box-shadow: 4px 4px 15px 0px #00000040;

  > button {
    width: 130px;
    height: 40px;
    border-radius: 8px;
    position: absolute;
    background-color: ${({ theme }) => theme.color[2]};
    bottom: 15px;
    right: 15px;
  }
`;

const Title = styled.p`
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  color: #151619;
  margin-bottom: 12px;
`;

const Content = styled.p`
  white-space: pre-line;
  ${({ theme }) => theme.typography.REGULAR_12};
  color: ${({ theme }) => theme.color[4]};
`;

const ErrorMessage = styled.p`
  ${({ theme }) => theme.typography.MEDIUM_16};
  color: ${({ theme }) => theme.color.warningRed};
  margin-bottom: 8px;
`;
